var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"no-spacing"},[_c('v-col',{staticClass:"no-spacing"},[_c('Button',{attrs:{"label":"actions.reset"},on:{"click":_vm.reset}}),_c('Button',{attrs:{"label":"actions.save"},on:{"click":_vm.update}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }